module.exports = __webpack_public_path__ + "static/media/clock.fc471cbf.svg";